import { CreateUserFormType } from './CreateUserFormType';

export const createUserFormInitialValues =
  (): CreateUserFormType => ({
    email: '',
    name: '',
  });
